import { render, staticRenderFns } from "./index.vue?vue&type=template&id=86b537a0&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86b537a0')) {
      api.createRecord('86b537a0', component.options)
    } else {
      api.reload('86b537a0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=86b537a0&", function () {
      api.rerender('86b537a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HtHelpTag/index.vue"
export default component.exports